import styled from 'styled-components'

export const WhiteModal = styled.div`
    width: 38rem;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    top: 30%;
    gap: .5rem;
    background: white;
    border-radius: 0.625rem;
    box-shadow: var(--SombraBtns);
 `
